var map = {
	"./add_chart.svg": "459e",
	"./donut_chart.svg": "7149",
	"./horizontal_bar_chart.svg": "e6e3",
	"./horizontal_stacked_bar_chart.svg": "fb74",
	"./line_chart.svg": "03055",
	"./maximize.svg": "f098",
	"./selected/donut_chart.svg": "4b57",
	"./selected/horizontal_bar_chart.svg": "752c",
	"./selected/horizontal_stacked_bar_chart.svg": "37a0",
	"./selected/line_chart.svg": "62d2",
	"./selected/single_value_chart.svg": "c1a3",
	"./selected/stacked_line_chart.svg": "4f5f",
	"./selected/vertical_bar_chart.svg": "ff49",
	"./selected/vertical_stacked_bar_chart.svg": "3590",
	"./single_value_chart.svg": "3de7",
	"./stacked_line_chart.svg": "bf8d",
	"./vertical_bar_chart.svg": "fa5a",
	"./vertical_stacked_bar_chart.svg": "57d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";